import { createContext } from 'react';

const LayoutTypeContext = createContext();

export default LayoutTypeContext;
